module.exports = __webpack_public_path__ + "img/exclemation-mark-coral.e712859d.svg";